import styles from "./styles.module.scss";
import { FC, Props } from "./typings";
import { IReceiver } from "dto/IPackage";
import CopyIcon from "assets/icons/copy-new.svg?react";
import { useState } from "react";
import SendStatusBadge from "components/SendStatusBadge";
import { EParcelType } from "dto/EParcelType";
import EmailIcon from "assets/icons/aemail.svg?react";
import LetterIcon from "assets/icons/new_parcel.svg?react";
import NotaIcon from "assets/icons/nota_icon.svg?react";
import AdeIcon from "assets/icons/ade.svg?react";
import { ItemKind } from "dto/IKindItems";
import sanitizeHtml from "sanitize-html";
import AddPresonIcon from "assets/icons/personadd.svg?react";
import { Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";

const copy = (receiver: IReceiver) => {
  navigator.clipboard.writeText(receiver.Email ?? receiver.Name);
};

const OutgoingParcelReceiverRow: FC<Props> = ({
  pack,
  receiver,
  addReceiverToCase,
}) => {
  const { t } = useTranslation();
  const [added, setAdded] = useState<boolean>(false);

  const addToCase = (receiver: IReceiver) => {
    addReceiverToCase(receiver);
    setAdded(true);
  };

  const getParcelName = () => {
    if (!pack) {
      return "";
    }
    if (pack.Kind === ItemKind.CourtPortalDeliverance) {
      return t("packages.courtDelivery");
    }

    switch (receiver.ParcelType) {
      case EParcelType.NotaEncrypted:
        return t("outgoingParcelReceiver.notaEncrypted");
      case EParcelType.EDelivery:
      case EParcelType.EncryptedEDelivery:
        return receiver.EDeliveryAddress ?? t("packages.eDelivery");
      case EParcelType.ExternalEDelivery:
        return receiver.EDeliveryAddress ?? "e-Doręczenie (urzędowe)";
      case EParcelType.Puh:
        return "e-Doręczenia hybrydowe (PUH)";
      case EParcelType.Email:
        return receiver.Email ?? t("outgoingParcelReceiver.emailType");
      case EParcelType.TraditionalLetter:
        return t("packages.traditional");
      case EParcelType.ContactMessage:
        return t("packages.encryptedPackage");
    }
    return "";
  };

  const getParcelIcon = () => {
    switch (receiver.ParcelType) {
      case EParcelType.EDelivery:
      case EParcelType.EncryptedEDelivery:
      case EParcelType.ExternalEDelivery:
        return <AdeIcon></AdeIcon>;
      case EParcelType.Email:
        return <EmailIcon></EmailIcon>;
      case EParcelType.NotaEncrypted:
        return <NotaIcon></NotaIcon>;
      case EParcelType.ContactMessage:
        return <NotaIcon></NotaIcon>;
      default:
        return <LetterIcon></LetterIcon>;
    }
  };

  return (
    <div className={styles.box}>
      <div className={styles.info}>
        <div
          className={styles.name}
          dangerouslySetInnerHTML={{
            __html: sanitizeHtml(
              receiver?.CompanyName ??
                `${receiver?.Name} ${receiver?.Surname ?? ""}`,
            ),
          }}
        ></div>
        <div className={styles.email}>
          <div className={styles.icon}>{getParcelIcon()}</div>
          <div dangerouslySetInnerHTML={{ __html: getParcelName() }}></div>
        </div>
      </div>
      <div className={styles.status}>
        {receiver.SendStatus && (
          <SendStatusBadge
            status={receiver.SendStatus}
            edeliveryEvent={receiver.NewestEvidenceEvent}
            showName={true}
          ></SendStatusBadge>
        )}
      </div>
      {addReceiverToCase && !added && (
        <div className={styles.addperson} onClick={() => addToCase(receiver)}>
          <Tooltip title={t("outgoingParcelReceiver.addToAddressList")}>
            <div>
              <AddPresonIcon></AddPresonIcon>
            </div>
          </Tooltip>
        </div>
      )}
      <div className={styles.copy} onClick={() => copy(receiver)}>
        <Tooltip title={t("common.copy")}>
          <div>
            <CopyIcon></CopyIcon>
          </div>
        </Tooltip>
      </div>
    </div>
  );
};

export default OutgoingParcelReceiverRow;
